import React, { useMemo, forwardRef } from "react";

import { ListItemText, ListItemSecondaryAction, IconButton, Button } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useNavigate } from "react-router-dom";

// Styles
import { Tree } from "api/types";
import { moreThanNDays, getDateToNow } from "utils/date";

import {
  StyledButtonWaze,
  StyledButtonWazeImage,
  StyledTreeListItem,
  StyledTreeListItemError,
} from "./HomePage.styles";
// Interfaces
// Assets
import WazeImg from "../../detail/waze.png";

// Utils

interface Props {
  tree: Tree;
  onStartWatering(id: string): void;
  daysDelayed: number;
}

const HomePageTreeListItem = forwardRef<HTMLDivElement, Props>(({ tree, onStartWatering, daysDelayed }, ref) => {
  const navigate = useNavigate();

  const onGoRoute = (id: string) => {
    navigate(`/detail/${id}`);
  };

  const onRouteWaze = (latitude: number, longitude: number) => {
    window.location.href = `https://www.waze.com/ul?ll=${latitude},${longitude}&navigate=yes&zoom=17`;
  };

  const lastWatering = tree.lastWateringAt ? `${getDateToNow(tree.lastWateringAt)}` : "No data";

  const secondary = useMemo(() => {
    return `${tree.timeDistance ? tree.timeDistance + "min " : ""}${
      typeof tree.distance === "number" ? tree.distance.toFixed(2) : "N/A"
    }mile(s) Last Watering: ${lastWatering}`;
  }, [tree.timeDistance, tree.distance, lastWatering]);

  const hasMoreThanNDays = tree.lastWateringAt && moreThanNDays(tree.lastWateringAt, daysDelayed);
  const ListItemComponent = hasMoreThanNDays ? StyledTreeListItemError : StyledTreeListItem;

  return (
    <ListItemComponent ref={ref} key={tree.id} divider onClick={() => onGoRoute(tree.id)}>
      <ListItemText sx={{ marginRight: 3 }} primary={tree.address ? tree.address : ""} secondary={secondary} />
      <ListItemSecondaryAction>
        <StyledButtonWaze component={Button} onClick={() => onRouteWaze(tree.latitude, tree.longitude)}>
          <StyledButtonWazeImage src={WazeImg} alt="wazeicon" />
        </StyledButtonWaze>
        <IconButton onClick={() => onStartWatering(tree.id)}>
          <CheckCircleIcon fontSize="large" color="primary" />
        </IconButton>
      </ListItemSecondaryAction>
    </ListItemComponent>
  );
});

HomePageTreeListItem.displayName = "HomePageTreeListItem";

export default HomePageTreeListItem;
